export function ImmersiveVoteErrorPage() {
  return null;
}
